import type { PiniaPluginContext } from 'pinia'
import { defineNuxtPlugin } from '#app'
import 'pinia'

/**
 * Augment the store options to include the persist option.
 * https://pinia.vuejs.org/core-concepts/plugins.html#store-options
 */
declare module 'pinia' {
  // @ts-ignore: this is a workaround to make session storage work
  export interface DefineStoreOptionsBase {
    persist?: boolean
  }
}

const piniaPersistPlugin = ({ store, options }: PiniaPluginContext) => {
  // @ts-ignore: this is a workaround to make session storage work
  const persist = options?.persist ? options.persist : false
  if (persist) {
    const storedState = sessionStorage.getItem(store.$id)
    if (storedState) {
      store.$patch(JSON.parse(storedState))
    }

    store.$subscribe((_, state) => {
      sessionStorage.setItem(store.$id, JSON.stringify(state))
    })
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  // @ts-ignore: this is a workaround to make session storage work
  nuxtApp.$pinia.use(piniaPersistPlugin)
})
